exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-check3[data-v-c184bc24]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-c184bc24]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #3b79b0}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-c184bc24]{font-size:1.5em}a.button.btn-large[data-v-c184bc24],button.btn-large[data-v-c184bc24],input[type=button].button.btn-large[data-v-c184bc24]{font-size:1em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c184bc24","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/booking/passengers/Passengers.vue
// module id = 452
// module chunks = 0